import React, {Component} from 'react';
import {Link} from 'react-router-dom';

import './Blog.css';
import Header from 'components/common/header/Header';
import Footer from 'components/common/footer/Footer';
import InfoBlog from 'components/common/infoBlog/InfoBlog';
import articles from 'config/articles';


class Blog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      maxTitle: Blog.getCounterMaxTitle()
    };

    this.handleResize = this.handleResize.bind(this)
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleResize);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
  }

  static getCounterMaxTitle() {
    const width = window.innerWidth;

    if (width > 1199) return 90;
    if (width > 991) return 70;
    if (width > 767) return 90;

    return 80;
  }

  handleResize() {
    this.setState({
      maxTitle: Blog.getCounterMaxTitle()
    })
  }

  render() {
    const maxTitle = this.state.maxTitle;
    return (
      <div className="c-blog">
        <Header
          urlBack='/'
          titleBack='Home'
        />

        <div className="list-articles container row">
          {
            articles.map((article, index) => {
              const url = `/blog/${article.path}`;
              const title = article.title.length > maxTitle ? `${article.title.substring(0, maxTitle)}...` : article.title;

              return (
                <div className="col-4" key={index}>
                  <article>
                    <Link className="image" to={url}>
                      <img src={article.image} alt={article.title}/>
                    </Link>

                    <div className="content">
                      <Link to={url}>
                        <h3>{title}</h3>
                      </Link>

                      <InfoBlog article={article}/>
                    </div>
                  </article>
                </div>
              );
            })
          }
        </div>
        <Footer/>
      </div>
    );
  }
}

export default Blog;



// WEBPACK FOOTER //
// ./src/components/core/blog/Blog.jsx